// extracted by mini-css-extract-plugin
module.exports = {"root":"Select_root__udO06","popup":"Select_popup__AVTzJ"};